import { BaseEnum } from "../../../../enums/baseEnum";

const listWCKOccurrenceStatusEnum: Array<WCKOccurrenceStatusEnum> = [];

export type WCKOccurrenceStatusType = "PARTIALLY_FINISHED";

export class WCKOccurrenceStatusEnum extends BaseEnum {
  static DRAFT = new WCKOccurrenceStatusEnum(
    1,
    "DRAFT",
    "Rascunho",
    "secondary"
  );
  static PENDING = new WCKOccurrenceStatusEnum(
    2,
    "PENDING",
    "Pendente",
    "warning"
  );
  static FINISHED = new WCKOccurrenceStatusEnum(
    3,
    "FINISHED",
    "Finalizada",
    "success"
  );
  static PARTIALLY_FINISHED = new WCKOccurrenceStatusEnum(
    4,
    "PARTIALLY_FINISHED",
    "Parc. Finalizado",
    "info"
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public className: string
  ) {
    super(id, value, label, className);
    listWCKOccurrenceStatusEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listWCKOccurrenceStatusEnum;
  }
}
